import { Message } from '@stomp/stompjs';
import {
    WEBSOCKET_ACTIONS,
    WebsocketWorkerType
} from './WebsocketWorker.types';
import Websocket from './websocket';
import { WebsocketWorkerMessageEvent } from './WebsocketWorker.types';

export type CustomMessageEvent = {
    task: string;
    userId: string;
    websocketUrl: string;
    routingKey: string;
    token: string;
};

class WebsocketWorker implements WebsocketWorkerType {
    postMessage(CustomMessageEvent: CustomMessageEvent) {
        self.postMessage(CustomMessageEvent);
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    addEventListener(message: string, listener: (e: any) => unknown) {
        self.addEventListener(message, listener);
    }
    webSocket: Websocket | undefined;
    onmessage!: (
        event: MessageEvent | CustomMessageEvent | WebsocketWorkerMessageEvent
    ) => void;

    constructor() {
        this.webSocket = undefined;
        self.onmessage = this.receive.bind(this);
    }
    onerror!: (e: MessageEvent) => void;
    removeEventListener!: (
        message: string,
        listener: (e: MessageEvent) => void,
        type?: WEBSOCKET_ACTIONS
    ) => void;

    /** @param {MessageEvent} e */
    receive({ data }: MessageEvent) {
        if (data?.task) {
            switch (data.task) {
                case WEBSOCKET_ACTIONS.INITIALIZE: {
                    this.webSocket = new Websocket(
                        data.userId,
                        data.token,
                        data.websocketUrl
                    );
                    const websocketCallback = (message: Message) => {
                        if (message.body) {
                            const messageBody = JSON.parse(message.body);
                            switch (message.headers.type) {
                                case 'calculationProgress': {
                                    self.postMessage({
                                        task: WEBSOCKET_ACTIONS.CALCULATION_PROGRESS,
                                        message: messageBody
                                    });
                                    break;
                                }
                                case 'calculationResult': {
                                    self.postMessage({
                                        task: WEBSOCKET_ACTIONS.CALCRESULTS_RECEIVED,
                                        message: messageBody
                                    });
                                    break;
                                }
                                case 'calculationFailed': {
                                    self.postMessage({
                                        task: WEBSOCKET_ACTIONS.CALCULATION_FAILED,
                                        message: messageBody
                                    });
                                    break;
                                }
                                case 'printResult': {
                                    self.postMessage({
                                        task: WEBSOCKET_ACTIONS.PRINT_RESULT,
                                        message: messageBody
                                    });
                                    break;
                                }
                                case 'printFailed': {
                                    self.postMessage({
                                        task: WEBSOCKET_ACTIONS.PRINT_FAILED,
                                        message: messageBody
                                    });
                                    break;
                                }
                                case 'ahuCreated': {
                                    self.postMessage({
                                        task: WEBSOCKET_ACTIONS.AHU_CREATED,
                                        message: messageBody
                                    });
                                    break;
                                }
                                default: {
                                    break;
                                }
                            }
                        }
                    };
                    this.webSocket.init(data.routingKey, websocketCallback);
                    break;
                }
                case WEBSOCKET_ACTIONS.DISCONNECT:
                    if (this.webSocket) {
                        this.webSocket.disconnect();
                    }
                    break;
                default:
                    break;
            }
        }
    }
}

export default new WebsocketWorker();
